<template lang="pug">
    Modal
        .form
            h2 Upload New Product Image
            .fuck
                img(
                    v-if="newImage"
                    :src="newImage"
                )
            .no-image(
                v-if="!image"
            )
                form(
                    ref="form"
                )
                    input(
                        name="imageContainer"
                        type="file"
                        v-on:change="onFileChange"
                        accept="image/*"
                    )
            .image__editor(
                v-else
            )
                .image__container
                    img(
                        :src="image"
                    )
                .button__container
                    button.button__submit(
                        @click="uploadImage"
                    ) Upload
                    button.button__action(
                        @click="removeImage"
                    ) Change Image
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postImage, postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'ProductImageUpload',
  components: {
    Modal
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  computed: {
    getActiveProduct: {
      get: function() {
        return store.getters.getActiveProduct;
      },
      set: function(product) {
        store.commit('setActiveProduct', product);
      }
    }
  },
  data() {
    return {
      image: '',
      imageFile: '',
      newImage: ''
    };
  },
  beforeDestroy() {
      store.commit('setIsPrimaryImage', false);
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.imageFile = files[0];

      this.createImage(files[0]);
    },
    createImage(file) {
      const image = new Image();
      const reader = new FileReader();
      const vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    base64MimeType(encoded) {
      let result = null;

      if (typeof encoded !== 'string') {
        return result;
      }

      const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

      if (mime && mime.length) {
        result = mime[1];
      }

      return result;
    },
    uploadImage() {
      const imageData = {};
      imageData.image = this.image;
      const imageJSON = JSON.stringify(imageData);
      postImage(
        '/v1/products/images/add',
        `productId=${this.getActiveProduct._id}`,
        this.image
      )
        .then(res => {
          // get image url back
          this.showSuccessMsg({
            message: `New image uploaded successfully. Be sure to save your changes!`
          });
          const activeLocalRecord = { ...store.getters.getActiveLocalRecord };
          if (!activeLocalRecord.images) {
            activeLocalRecord.images = [];
          }

        if(store.getters.getIsEditingPrimaryImage) {
            activeLocalRecord.images.unshift(res.imageUrl);
        } else {
            activeLocalRecord.images.push(res.imageUrl);
        }

          store.commit('setActiveLocalRecord', activeLocalRecord);
          return res;
        })
        .then((res) => {
            store.commit('hideModals', true);
        })
        .catch(error => {
          let message = 'An error occurred. Please try again.';
          if (typeof error.error === 'string' || error.error instanceof String) {
            message = error.error;
          } else if(error.message) {
              message = error.message;
          }
          return this.showErrorMsg({
            message
          });
        });
    },
    removeImage(e) {
      this.image = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 0 1.6rem;

  h2 {
    text-align: center;
  }

  .no-image {
    margin: auto;
    text-align: center;
  }

  .image__container {
    img {
      display: block;
      margin: auto;
      max-width: 400px;
    }
  }

  .button__container {
    display: flex;
    margin: 1.6rem auto;
    width: 100%;
    max-width: 400px;

    button {
      margin: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ProductImageUpload.vue